var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPopular(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1505 23.7188C15.3439 21.9539 15.4539 20.0478 14.4804 18.0003C14.2097 19.0988 13.7145 19.7654 12.9948 20.0004C13.6632 18.0917 13.1047 16.0296 11.3194 13.814C11.2808 16.1023 10.7309 17.7691 9.66965 18.8147C8.20761 20.2536 8.22482 21.8775 9.72121 23.6865C3.50943 20.3807 2.63305 15.9471 7.09199 10.3857C7.36855 11.7292 8.03872 12.5541 9.1026 12.8603C7.94296 7.93931 9.16307 3.7463 12.7629 0.28125C12.785 7.97095 15.1431 8.65444 18.1244 12.087C21.3434 16.2061 19.4518 20.9598 14.1505 23.7188Z",
    fill: "url(#paint0_linear_286_20255)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_286_20255",
    x1: 19.1954,
    y1: 6.71381,
    x2: 5.48202,
    y2: 20.4272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EF3E3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC828"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPopular);
export default __webpack_public_path__ + "static/media/icon_popular.a4d70a0ba7d4b5b0cdf5d5ca5c25c22d.svg";
export { ForwardRef as ReactComponent };